export default {
  C: "Ντο",
  CSharp: "Ντο♯",
  D: "Ρε",
  DFlat: "Ρε♭",
  DSharp: "Ρε♯",
  E: "Μι",
  EFlat: "Μι♭",
  F: "Φα",
  FSharp: "Φα♯",
  G: "Σολ",
  GFlat: "Σολ♭",
  GSharp: "Σολ♯",
  A: "Λα",
  AFlat: "Λα♭",
  ASharp: "Λα♯",
  B: "Σι",
  BFlat: "Σι♭",

  correctExcl: "Σωστό!",
  wrongExcl: "Λάθος!",

  ABORT: "ΑΚΥΡΩΣΗ",

  lastRound: "Τελευταίος γύρος",
  score: "Βαθμολογία",
  accuracy: "Ακρίβεια",
  correct: "σωστά",
  wrong: "λάθη",

  START: "ΕΝΑΡΞΗ",
  settings: "Ρυθμίσεις",
  ROUND_LENGTH: "ΔΙΑΡΚΕΙΑ ΓΥΡΟΥ",
  NOTE_INPUT: "ΕΙΣΑΓΩΓΗ ΝΟΤΑΣ",
  CLEF: "ΚΛΕΙΔΙ",
  DIFFICULTY: "ΔΥΣΚΟΛΙΑ",
  ACCIDENTALS: "ΑΛΛΟΙΩΣΕΙΣ",
  LANGUAGE: "ΓΛΩΣΣΑ",
  twentySeconds: "20 δευτ.",
  oneMinute: "1 λεπτό",
  fiveMinutes: "5 λεπτά",
  infinite: "Άπειρο",
  buttons: "Κουμπιά",
  piano: "Πιάνο",
  trebleClef: "Κλειδί του Σολ",
  bassClef: "Κλειδί του Φα",
  altoClef: "Κλειδί του Ντο (Άλτο)",
  tenorClef: "Κλειδί του Ντο (Τενόρος)",
  pianoClef: "Πιάνο",
  easy: "Εύκολο",
  normal: "Κανονικό",
  hard: "Δύσκολο",
  none: "Καμία",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ and ♭",
  SOUND: "ΗΧΟΣ",
  VIBRATION: "ΔΟΝΗΣΗ",
  DISPLAYCORRECTNOTE: "ΕΜΦΑΝΙΣΗ ΣΩΣΤΗΣ ΝΟΤΑΣ",
  on: "Ενεργό",
  off: "Ανενεργό",

  TIME: "ΧΡΟΝΟΣ",
  CORRECT: "ΣΩΣΤΟ",
  ACCURACY: "ΑΚΡΙΒΕΙΑ",
  SCORE: "ΒΑΘΜΟΛΟΓΙΑ",

  record: "Υψηλή βαθμολογία",
  history: "Ιστορικό",

  noMidiSupport: "Συγνώμη, φαίνεται πως η συσκευή σας δεν υποστηρίζει MIDI.",
  noDeviceFound: "Δεν βρέθηκε συσκευή. Παρακαλώ συνδέστε ξανά την συσκευή MIDI.",
  playTheNote: "Παίξτε τη νότα στο πληκτρολόγιο του MIDI σας.",
  lastNotePlayed: "Η τελευταία νότα που παίχτηκε",
};



// WEBPACK FOOTER //
// ./src/resources/el.js